/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DmvsDtiDocsImportInterruptPartialUpdateRequest = {} | null | undefined;
export type DmvsDtiDocsImportInterruptPartialUpdateResponse = any;

export type DmvsDtiDocsImportInterruptPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/dmvs_dti_docs/{id}/import_interrupt/
 *
 * ```yaml
 * operationId: dmvs_dti_docs_import_interrupt_partial_update
 * tags:
 *   - dmvs_dti_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsDtiDocsImportInterruptPartialUpdateOperation = ({
  id,
  ...rest
}: DmvsDtiDocsImportInterruptPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/dmvs_dti_docs/${id}/import_interrupt/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/dmvs_dti_docs/{id}/import_interrupt/' };
  };

/**
 * PATCH /dmx-server/dmvs_dti_docs/{id}/import_interrupt/
 *
 * ```yaml
 * operationId: dmvs_dti_docs_import_interrupt_partial_update
 * tags:
 *   - dmvs_dti_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsDtiDocsImportInterruptPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DmvsDtiDocsImportInterruptPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = dmvsDtiDocsImportInterruptPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
